export default "__VITE_ASSET__DbP6eBz4__"